import store from '@/store'
export default [
  {
    path: '/rooms',
    name: 'room',
    meta: { requiresAuth: true },
    component: () => import('@/pages/room/index-v2.vue'),
    beforeEnter: (to, from, next) => {
      store.dispatch('room/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/rooms/create',
    name: 'room-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/room/create.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('room/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/rooms/:id',
    name: 'room-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/room/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('room/dataBeforeCreate')
      await store.dispatch('room/find', to.params.id)
      next()
    }
  }
]
